import './PhotoGallery.css';
import { LoadingState, ErrorState } from '../../../components';

function PhotoGallery({ photos, loading, error, loadMore, hasMore }) {

  if (loading) {
    return (
      <section className="photo-gallery">
        <div className="gallery-container">
          <h5>Un po' di nostre foto</h5>
          <LoadingState message="Caricamento foto..." />
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="photo-gallery">
        <div className="gallery-container">
          <h5>Un po' di nostre foto</h5>
          <ErrorState message="Errore nel caricamento delle foto" />
        </div>
      </section>
    );
  }

  if (!photos || photos.length === 0) {
    return (
      <section className="photo-gallery">
        <div className="gallery-container">
          <h5>Un po' di nostre foto</h5>
          <div className="no-data-message">
            <p>Nessuna foto disponibile</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="photo-gallery">
      <div className="gallery-container">
        <h5>Un po' di nostre foto</h5>
        <div className="gallery-grid">
          {photos.map((photo, index) => (
            <div key={index} className="gallery-item">
              <a href={photo} target="_blank" rel="noopener noreferrer">
                <img 
                  src={photo} 
                  alt={`Attività e momenti della Consulta Giovanile di Ortona - Foto ${index + 1}`} 
                />
                <div className="gallery-overlay">
                  <i className="fa-solid fa-magnifying-glass-plus"></i>
                </div>
              </a>
            </div>
          ))}
        </div>
        {hasMore && (
          <div className="load-more-container">
            <button onClick={loadMore} className="load-more-button">
              Mostra altre foto
            </button>
          </div>
        )}
      </div>
    </section>
  );
}

export default PhotoGallery;
